// extracted by mini-css-extract-plugin
export default {"icon":"fk6zU","img":"mG2hv","icon-loader":"bxylZ","loader-spin":"huR47"};